export * from './lazy.decorator';
